import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  Avatar,
  Box,
  Typography,
} from '@mui/material';
import {
  Logout,
  Person,
  Business,
  Group,
  AccountTree,
  Assessment,
  History,
  Help,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

const ProfileMenu = ({
  anchorEl,
  open,
  onClose,
  onSignOut,
  isMobile = false,
  checkMenuPermission,
  setPreviousParams,
  showAllOptions = true,
  auth, // New prop
  roles, // New prop
}) => {
  const handleClose = () => {
    onClose();
  };

  const handleSignOut = () => {
    onSignOut();
    handleClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id={isMobile ? "mobile-profile-menu" : "desktop-profile-menu"}
      open={open && Boolean(anchorEl)}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          width: isMobile ? '280px' : 320,
          overflow: "visible",
          filter: "drop-shadow(0px 8px 24px rgba(0,0,0,0.12))",
          mt: isMobile ? 0 : 1.5,
          borderRadius: "12px",
          border: "1px solid #E5E7EB",
          "& .MuiMenuItem-root": {
            fontFamily: "'Manrope', sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            padding: "10px 16px",
            margin: "4px 8px",
            borderRadius: "8px",
            transition: "all 0.2s ease",
            color: "#374151",
            "&:hover": {
              background: "#F3F4F6",
              color: "#2259c9",
              "& .MuiListItemIcon-root": {
                color: "#2259c9",
              },
            },
          },
        },
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: isMobile ? "center" : "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: isMobile ? "center" : "right",
      }}
      sx={isMobile ? {
        '& .MuiPaper-root': {
          position: 'fixed !important',
          bottom: '16px !important',
          top: 'auto !important',
          left: '50% !important',
          transform: 'translateX(-50%) !important',
          margin: '0 !important',
        }
      } : {}}
    >
      {auth && (
        <Box sx={{ px: 2.5, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            src={`/assets/avatars/${auth.avatar}.png`}
            alt={auth.fullName}
            sx={{ width: 44, height: 44, border: '2px solid #E5E7EB' }}
          />
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '15px', color: '#111827', lineHeight: 1.2 }}>
              {auth.fullName}
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: 0.5, fontWeight: 500 }}>
              {roles[auth.type] || auth.type}
            </Typography>
          </Box>
        </Box>
      )}

      <Divider sx={{ my: 1, borderColor: '#F3F4F6' }} />

      {showAllOptions && [
        <MenuItem key="profile" component={Link} to={setPreviousParams("/settings/profile")}>
          <ListItemIcon>
            <Person fontSize="small" />
          </ListItemIcon>
          Manage profile
        </MenuItem>,

        checkMenuPermission(["super", "total"]) && (
          <MenuItem key="facilities" component={Link} to={setPreviousParams("/settings/facilities")}>
            <ListItemIcon>
              <Business fontSize="small" />
            </ListItemIcon>
            Manage facilities
          </MenuItem>
        ),

        checkMenuPermission([
          "super",
          "total",
          "owner",
          "admin",
          "regional",
        ]) && (
          <MenuItem key="users" component={Link} to={setPreviousParams("/settings/users")}>
            <ListItemIcon>
              <Group fontSize="small" />
            </ListItemIcon>
            Manage users
          </MenuItem>
        ),

        checkMenuPermission(["super"]) && (
          <MenuItem key="accounts" component={Link} to={setPreviousParams("/settings/accounts")}>
            <ListItemIcon>
              <AccountTree fontSize="small" />
            </ListItemIcon>
            Manage accounts
          </MenuItem>
        ),

        checkMenuPermission(["super"]) && (
          <MenuItem key="audit-logs" component={Link} to={setPreviousParams("/settings/security/audit-logs")}>
            <ListItemIcon>
              <Assessment fontSize="small" />
            </ListItemIcon>
            Audit logs
          </MenuItem>
        ),

        checkMenuPermission([
          "super",
          "total",
          "owner",
          "admin",
          "regional",
        ]) && (
          <MenuItem key="timelog" component={Link} to={setPreviousParams("/logs")}>
            <ListItemIcon>
              <History fontSize="small" />
            </ListItemIcon>
            View timelog
          </MenuItem>
        ),

        <MenuItem key="tutorials" component={Link} to={setPreviousParams("/tutorials")}>
          <ListItemIcon>
            <Help fontSize="small" />
          </ListItemIcon>
          Tutorials
        </MenuItem>,

        <Divider key="divider-bottom" sx={{ my: 1, borderColor: '#F3F4F6' }} />
      ].filter(Boolean)}

      <MenuItem 
        onClick={handleSignOut}
        sx={{ 
          color: '#DC2626 !important',
          '&:hover': {
            background: '#FEF2F2 !important',
            '& .MuiListItemIcon-root': {
              color: '#DC2626 !important',
            },
          }
        }}
      >
        <ListItemIcon>
          <Logout fontSize="small" sx={{ color: '#DC2626' }} />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  );
};

export default ProfileMenu;